import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";
import { List, X, User } from "lucide-react";

const LINKS = [
  { to: "/", label: "Inicio" },
  { to: "/catalogo", label: "Catálogo" },
  { to: "/mapa", label: "Mapa" },
  { to: "/contratos", label: "Contratos" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="h-8 w-8 bg-brand flex items-center justify-center font-display font-black text-black text-xl">M</div>
          <span className="font-display font-black text-2xl tracking-tighter">MAQUI<span className="text-brand">PRO</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <ThemeToggle />
          {user ? (
            <div className="flex items-center gap-2">
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin"
                  className="text-sm font-semibold px-3 py-2 border border-border hover:border-brand transition-colors">
                  Admin
                </Link>
              )}
              <Link to="/panel" data-testid="nav-panel"
                className="text-sm font-semibold px-3 py-2 flex items-center gap-2 hover:text-brand transition-colors">
                <User size={16} /> {user.name?.split(" ")[0]}
              </Link>
              <button onClick={logout} data-testid="nav-logout"
                className="text-sm font-semibold px-4 py-2 bg-foreground text-background hover:bg-brand hover:text-black transition-colors">
                Salir
              </button>
            </div>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login"
                className="text-sm font-semibold px-4 py-2 border border-border hover:border-brand transition-colors">
                Ingresar
              </Link>
              <Link to="/registro" data-testid="nav-register"
                className="text-sm font-semibold px-4 py-2 bg-brand text-black hover:bg-brand-hover transition-colors">
                Registrarse
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <List />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background px-4 py-4 space-y-3">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block text-sm font-medium py-2">{l.label}</Link>
          ))}
          <div className="flex items-center gap-3 pt-2 border-t border-border">
            <ThemeToggle />
            {user ? (
              <>
                {user.role === "admin" && <button onClick={() => { navigate("/admin"); setOpen(false); }} className="text-sm font-semibold">Admin</button>}
                <button onClick={() => { navigate("/panel"); setOpen(false); }} className="text-sm font-semibold">Mi Panel</button>
                <button onClick={logout} className="text-sm font-semibold text-destructive">Salir</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-sm font-semibold">Ingresar</Link>
                <Link to="/registro" onClick={() => setOpen(false)} className="text-sm font-semibold px-4 py-2 bg-brand text-black">Registrarse</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
